import { Component } from '@angular/core';

@Component({
  selector: 'app-features',
  templateUrl: './features.html',
  styleUrl: './features.css',
})
export class Features {}
